import React from 'react'

export default function LogoImage({ className, alt }) {
    return (
        <img src="main_logo.png" alt={alt} className={className} />
    )
}
